import { Routes } from '@angular/router'

import { environment } from '@teknor/env/environment'

import { adminGuard } from './core/auth/admin.guard'
import { authGuard } from './core/auth/auth.guard'
import { redirectIfAuthGuard } from './core/auth/redirect-if-auth.guard'
import { interactionRoutes } from './pages/interactions/interactions.routes'

export const routes: Routes = [
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./layouts/main/main-layout.component').then((m) => m.MainLayoutComponent),
    children: [
      ...(environment.features['module.free-mode']
        ? ([
            {
              path: '',
              loadComponent: () =>
                import(
                  '@yoshu-lib/features/interaction-modes/free-mode/start-free-mode/start-free-mode.component'
                ).then((m) => m.StartFreeModeComponent)
            }
          ] as Routes)
        : []),

      {
        path: 'interactions',
        children: interactionRoutes
      },

      {
        path: 'conversations',
        loadComponent: () =>
          import('./pages/interactions-list/interactions-list.component').then(
            (m) => m.InteractionsListComponent
          )
      }
    ]
  },

  ...(environment.features['module.admin']
    ? [
        {
          path: 'admin',
          canActivate: [adminGuard],
          loadComponent: () =>
            import('./pages/admin/admin.component').then((m) => m.AdminComponent),
          children: [
            {
              path: '',
              loadChildren: () =>
                import('@yoshu-lib/features/admin/admin.routes').then((m) => m.routes)
            }
          ]
        } satisfies Routes[number]
      ]
    : []),

  {
    path: 'login',
    canActivate: [redirectIfAuthGuard],
    loadComponent: () => import('./pages/login/login.component').then((m) => m.LoginComponent)
  },

  {
    path: '**',
    redirectTo: ''
  }
]
